/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SingleTurnChatLanguageEnum } from './SingleTurnChatLanguageEnum';
import {
  SingleTurnChatLanguageEnumFromJSON,
  SingleTurnChatLanguageEnumFromJSONTyped,
  SingleTurnChatLanguageEnumToJSON,
} from './SingleTurnChatLanguageEnum';
import type { ResponsePath } from './ResponsePath';
import { ResponsePathFromJSON, ResponsePathFromJSONTyped, ResponsePathToJSON } from './ResponsePath';
import type { CredentialRead } from './CredentialRead';
import { CredentialReadFromJSON, CredentialReadFromJSONTyped, CredentialReadToJSON } from './CredentialRead';
import type { SingleTurnChatProtocolEnum } from './SingleTurnChatProtocolEnum';
import {
  SingleTurnChatProtocolEnumFromJSON,
  SingleTurnChatProtocolEnumFromJSONTyped,
  SingleTurnChatProtocolEnumToJSON,
} from './SingleTurnChatProtocolEnum';

/**
 *
 * @export
 * @interface PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApi
 */
export interface PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApi {
  /**
   *
   * @type {SingleTurnChatProtocolEnum}
   * @memberof PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApi
   */
  protocol: SingleTurnChatProtocolEnum;
  /**
   *
   * @type {number}
   * @memberof PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApi
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApi
   */
  name?: string | null;
  /**
   *
   * @type {SingleTurnChatLanguageEnum}
   * @memberof PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApi
   */
  language: SingleTurnChatLanguageEnum;
  /**
   *
   * @type {CredentialRead}
   * @memberof PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApi
   */
  readonly credential: CredentialRead;
  /**
   *
   * @type {Date}
   * @memberof PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApi
   */
  timestamp?: Date;
  /**
   *
   * @type {string}
   * @memberof PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApi
   */
  endpointUrl: string;
  /**
   *
   * @type {string}
   * @memberof PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApi
   */
  method: string;
  /**
   *
   * @type {string}
   * @memberof PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApi
   */
  requestTemplate: string;
  /**
   *
   * @type {Array<ResponsePath>}
   * @memberof PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApi
   */
  readonly responsePaths: Array<ResponsePath>;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApi
   */
  otherHeaders?: { [key: string]: string } | null;
}

/**
 * Check if a given object implements the PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApi interface.
 */
export function instanceOfPatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApi(
  value: object,
): value is PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApi {
  if (!('protocol' in value) || value['protocol'] === undefined) return false;
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('language' in value) || value['language'] === undefined) return false;
  if (!('credential' in value) || value['credential'] === undefined) return false;
  if (!('endpointUrl' in value) || value['endpointUrl'] === undefined) return false;
  if (!('method' in value) || value['method'] === undefined) return false;
  if (!('requestTemplate' in value) || value['requestTemplate'] === undefined) return false;
  if (!('responsePaths' in value) || value['responsePaths'] === undefined) return false;
  return true;
}

export function PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApiFromJSON(
  json: any,
): PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApi {
  return PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApiFromJSONTyped(json, false);
}

export function PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApiFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApi {
  if (json == null) {
    return json;
  }
  return {
    protocol: SingleTurnChatProtocolEnumFromJSON(json['protocol']),
    id: json['id'],
    name: json['name'] == null ? undefined : json['name'],
    language: SingleTurnChatLanguageEnumFromJSON(json['language']),
    credential: CredentialReadFromJSON(json['credential']),
    timestamp: json['timestamp'] == null ? undefined : new Date(json['timestamp']),
    endpointUrl: json['endpoint_url'],
    method: json['method'],
    requestTemplate: json['request_template'],
    responsePaths: (json['response_paths'] as Array<any>).map(ResponsePathFromJSON),
    otherHeaders: json['other_headers'] == null ? undefined : json['other_headers'],
  };
}

export function PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApiToJSON(
  value?: Omit<
    PatchedSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerCustomApi,
    'id' | 'credential' | 'responsePaths'
  > | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    protocol: SingleTurnChatProtocolEnumToJSON(value['protocol']),
    name: value['name'],
    language: SingleTurnChatLanguageEnumToJSON(value['language']),
    timestamp: value['timestamp'] == null ? undefined : value['timestamp'].toISOString(),
    endpoint_url: value['endpointUrl'],
    method: value['method'],
    request_template: value['requestTemplate'],
    other_headers: value['otherHeaders'],
  };
}
